export const DRILLS_QUESTIONS_REQUEST = "DRILLS_QUESTIONS_REQUEST";
export const DRILLS_QUESTIONS_SUCCESS = "DRILLS_QUESTIONS_SUCCESS";
export const  DRILLS_QUESTIONS_FAILURE = "DRILLS_MODULES_FAILURE";